import 'css-chunk:src/chips/chip.module.scss';export default {
  "heading-xxl": "chip-module__heading-xxl___S4YIy",
  "wrapper": "chip-module__wrapper___d6Jyx",
  "heading-xl": "chip-module__heading-xl___YZRLc",
  "heading-lg": "chip-module__heading-lg___Fx19c",
  "heading-md": "chip-module__heading-md___1X-xx",
  "heading-sm": "chip-module__heading-sm___H86PJ",
  "heading-xs": "chip-module__heading-xs___tYy29",
  "body-one": "chip-module__body-one___pZP8h",
  "body-two": "chip-module__body-two___5kHhf",
  "body-three": "chip-module__body-three___n7fHw",
  "body-four": "chip-module__body-four___AVLBz",
  "overline-one": "chip-module__overline-one___VtqKS",
  "overline-two": "chip-module__overline-two___kmuCH",
  "overline-three": "chip-module__overline-three___NFyJY",
  "strong": "chip-module__strong___dHCEa",
  "em": "chip-module__em___u3m-1",
  "figcaption": "chip-module__figcaption___HYvAm",
  "no-margin": "chip-module__no-margin___D-RT0",
  "chips": "chip-module__chips___0JGq7",
  "chipsContainer": "chip-module__chipsContainer___jtRGZ",
  "chip": "chip-module__chip___HKQlG",
  "chips-black": "chip-module__chips-black___Xq6mp",
  "chips-gray": "chip-module__chips-gray___eZjpH",
  "chips-l": "chip-module__chips-l___5KTqf",
  "groupLabel": "chip-module__groupLabel___8bgMu",
  "chip-thick": "chip-module__chip-thick___W-9l0",
  "chip-thin": "chip-module__chip-thin___-slju",
  "chips-m": "chip-module__chips-m___N1FgP",
  "chips-s": "chip-module__chips-s___PIiem",
  "chips-xs": "chip-module__chips-xs___upKD7"
};